import Index from "../components/RoleAssignmind/index";

const RoleAssignment = () => {
    return <Index />;
};

export default RoleAssignment;
